import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { Outlet, useOutletContext } from 'react-router';

import { TopBar, TopBarProps } from '@/true-fsd/widgets/TopBar';
import { CreateAccountWizard } from '@/true-fsd/widgets/CreateAccountWizard';

import classes from './AuthorizedLayout.module.scss';

type DialogKey = 'newAccount';

const useNewAccountDialog = (
  setOpenDialog: Dispatch<SetStateAction<'newAccount' | null>>,
) => {
  const openNewAccount = useCallback(
    () => setOpenDialog('newAccount'),
    [setOpenDialog],
  );
  const onNewAccountOpenChange = useCallback(
    (v: boolean) => {
      if (v) {
        setOpenDialog('newAccount');
      } else {
        setOpenDialog((od) => (od === 'newAccount' ? null : od));
      }
    },
    [setOpenDialog],
  );

  return {
    openNewAccount,
    onNewAccountOpenChange,
  };
};

export const AuthorizedLayout = () => {
  const context = useOutletContext();

  const [openDialog, setOpenDialog] = useState<DialogKey | null>(null);
  const { openNewAccount, onNewAccountOpenChange } =
    useNewAccountDialog(setOpenDialog);

  const RenderNewAccountItem: TopBarProps['RenderNewAccountItem'] = useCallback(
    ({ children, className }) => {
      return (
        <button type="button" className={className} onClick={openNewAccount}>
          {children}
        </button>
      );
    },
    [openNewAccount],
  );

  return (
    <div className={classes.root}>
      <TopBar
        RenderNewAccountItem={RenderNewAccountItem}
        className={classes.topBar}
      />
      <div className={classes.content}>
        <Outlet context={context} />
      </div>
      <CreateAccountWizard
        open={openDialog === 'newAccount'}
        onOpenChange={onNewAccountOpenChange}
      />
    </div>
  );
};
